import React from 'react';

import cn from 'classnames';
import {
  string,
  bool,
  shape,
  func,
  oneOf,
  oneOfType,
  number,
} from 'prop-types';

import MuiSwitch from '@mui/material/Switch';
import Typography from '@mui/material/Typography';

import s from './Toggle.css';

const styles = {
  small: s.small,
  medium: s.medium,
};

const Toggle = ({
  name,
  size,
  label,
  value,
  checked,
  classes,
  disabled,
  onChange,
  containerClass,
  labelDirection,
  testId,
  'aria-label': ariaLabel,
}) => (
  <div
    className={cn(s.root, containerClass, styles[size], {
      [s.labelLeft]: labelDirection === 'left' && label,
      [s.labelTop]: labelDirection === 'top' && label,
    })}
  >
    <MuiSwitch
      id={name}
      name={name}
      size={size}
      value={value}
      checked={checked}
      disabled={disabled}
      onChange={onChange}
      classes={{
        root: s.switch,
        thumb: s.switchThumb,
        track: s.switchTrack,
        checked: s.switchChecked,
        switchBase: s.switchBase,
        disabled: s.switchDisabled,
        ...classes,
      }}
      inputProps={{
        'data-testid': testId,
        ...(ariaLabel ? { 'aria-label': ariaLabel } : {}),
      }}
    />
    {label ? (
      <Typography
        component="label"
        htmlFor={name}
        classes={{
          root: cn(s.label, { [s.disabledLabel]: disabled }),
        }}
      >
        {label}
      </Typography>
    ) : null}
  </div>
);

Toggle.propTypes = {
  name: string,
  label: string,
  disabled: bool,
  classes: shape({}),
  containerClass: string,
  checked: bool.isRequired,
  onChange: func.isRequired,
  size: oneOf(['small', 'medium']),
  labelDirection: oneOf(['left', 'right']),
  value: oneOfType([string, number, bool, shape({})]).isRequired,
  testId: string,
  'aria-label': string,
};

Toggle.defaultProps = {
  name: '',
  label: '',
  classes: {},
  size: 'medium',
  disabled: false,
  containerClass: '',
  labelDirection: 'right',
  testId: '',
  'aria-label': '',
};

export default Toggle;
